import { useContent } from '../../contexts/ContentContext'
import SectionWrapper from '../ui/SectionWrapper'
import SectionLabel from '../ui/SectionLabel'
import PodcastPlayer from '../ui/PodcastPlayer'

const SECTION_BG = "https://media.thelightcall.com/images/podcast%20bg%20blur.jpg"

export default function PodcastSection() {
  const { podcasts } = useContent()
  // podcasts is an array on regression; other sites may omit it
  const podcast = Array.isArray(podcasts) ? podcasts[0] : null
  if (!podcast) return null

  return (
    <SectionWrapper
      id="podcast"
      className="relative overflow-hidden md:min-h-screen md:flex md:flex-col md:justify-center"
      data-testid="podcast-player-section"
    >
      <div className="absolute inset-0 bg-cover bg-center backdrop-blur-sm" style={{ backgroundImage: `url(${SECTION_BG})` }} />
      <div className="absolute inset-0 bg-color-bg-light/75" />

      <div className="relative z-10">
        <div className="flex flex-col gap-4 md:grid md:grid-cols-2 md:grid-rows-[auto_auto_auto] md:card-grid-gap-lg items-start">

          {/* Header: mobile order 1, desktop top-left */}
          <div className="order-1 md:col-start-1 md:row-start-1 w-full">
            <SectionLabel text={podcast.label} />
            <h2 className="typography-hero-mobile md:typography-hero leading-tight heading-body-spacing">
              {podcast.sectionHeadline}
            </h2>
          </div>

          {/* Player: mobile order 2 (between headline and body), desktop right column spans all rows */}
          <div className="order-2 md:col-start-2 md:row-start-1 md:row-span-3 w-full flex justify-center md:justify-end md:items-start">
            <PodcastPlayer
              title={podcast.youtubeTitle}
              host={podcast.episodeHost}
              episodeLabel={podcast.episodeLabel}
              thumbnailUrl="https://media.thelightcall.com/images/spotify-bergesund.jpeg.webp.png.webp"
              audioUrl={podcast.episodeAudioUrl}
            />
          </div>

          {/* Body: mobile order 3, desktop left-col row 2 */}
          <p className="order-3 md:col-start-1 md:row-start-2 typography-body-lg leading-relaxed">
            {podcast.sectionBody}
          </p>

          {/* Buttons: mobile order 4, desktop left-col row 3 */}
          <div className="order-4 md:col-start-1 md:row-start-3 flex flex-wrap gap-3 w-full">
            {podcast.podcastLinks.map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noreferrer"
                className="typography-menu-text text-color-primary border border-color-primary/30 rounded-none px-5 py-2.5 hover:bg-color-primary hover:text-primary-on-dark transition-colors flex-1 text-center"
                data-testid={`podcast-link-${link.label.toLowerCase().replace(/ /g, '-')}`}
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </SectionWrapper>
  )
}
